import styles from './modalWindow.module.scss';
import { ReactComponent as CloseIcon } from '../../images/close.svg';
import {
  useEffect,
  useRef
} from "react";
import ReactDOM from "react-dom";
import { createUUID } from "../../../utils/shared.utils";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  AppDispatch,
  RootState
} from "../../../store";
import {
  addOpenModal,
  removeOpenModal
} from "../../../store/slices/mainSlice";

type ModalWindowProps = {
  children: string | JSX.Element | JSX.Element[];
  title: string;
  onClose: () => void;
  width: number;
  showTooltip?: boolean;
}

export const ModalWindow = ({ children, title, onClose, width, showTooltip }: ModalWindowProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const modalIdRef = useRef(createUUID());

  const openModalsId = useSelector((state: RootState) => state.mainSlice.openModalsId);

  useEffect(() => {
    dispatch(addOpenModal(modalIdRef.current));

    return () => {
      dispatch(removeOpenModal());
    }
  }, [dispatch]);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent): void => {
      if (e.key === "Escape") {
        const lastOpenModalId = [...openModalsId].pop();
        if (lastOpenModalId === modalIdRef.current) {
          onClose();
        }
      }
    }

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    }
  }, [openModalsId, onClose]);

  return ReactDOM.createPortal(
    <div className={styles.container}>
      <div className={styles.bodyContainer}>
        <div className={styles.header}></div>
        <div className={styles.body} style={{ width }}>
          <div className={styles.title}>
            <span title={!!showTooltip ? title : undefined}>{title}</span>
            <CloseIcon onClick={onClose}/>
          </div>
          {children}
        </div>
      </div>
    </div>,
    document.body);
}